import { alerts, dashboards, devices, reports } from './manager';

export const baseNavigation = [dashboards, alerts, reports, devices];
